import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { CandidacyQuery as CandidacyQueryType, CandidacyQueryVariables } from "./__generated__/CandidacyQuery";

const CandidacyQuery = loader("./CandidacyQuery.gql");

type CandidacyQueryProviderType = (props: {
  children: (data: CandidacyQueryType) => ReactNode;
  variables: CandidacyQueryVariables;
}) => ReactElement;

export const CandidacyQueryProvider: CandidacyQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<CandidacyQueryType, CandidacyQueryVariables>(CandidacyQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
